import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { ErrorCustom } from '@/utils/client';
import { get } from '@/utils/client';

import { DEVICE_TOKEN } from '@/routes/apiEndpoints';

type DeviceTokenType = {
    app_installed: boolean;
    has_new_app: boolean;
};

const useDeviceToken = (options?: SWRConfiguration<DeviceTokenType, ErrorCustom>) => {
    const {
        data: deviceToken,
        mutate: mutateDeviceToken,
        error: deviceTokenError,
        isLoading
    } = useSWR<DeviceTokenType, ErrorCustom>(
        DEVICE_TOKEN,
        (url) => get<{ data: DeviceTokenType }>(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        deviceToken,
        mutateDeviceToken,
        deviceTokenError,
        isLoading
    };
};
export default useDeviceToken;
